import type { WebsiteHeaderPhotoSchema_Center } from '@shared/types/WebsiteHeaderSettings.types';

export const CENTER_DEFAULT: WebsiteHeaderPhotoSchema_Center = {
  $id: 'https://withjoy.com/assets/public/websiteHeaderSchemas/center-v1_1_1.json',
  presentationLayout: 'center',
  photos: [],
};
